<template>
    <VACFApprovals></VACFApprovals>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const VACFApprovals = defineAsyncComponent(() =>
    import("../../components/Engineering/VACFApprovals.vue")
);

export default {
    name: "ENG_VACFApprovals", //The name you are in should not equal the name of the component you are importing.
    components: { VACFApprovals, AuthLayout },
};
</script>
